import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    MenuItem,
    Select,
    Stack,
    useTheme,
    TextField,
    Autocomplete
} from "@mui/material";
import {useContext, useState} from "react";
import OrderContext from "../../../context/OrderContext";
import Typography from "@mui/material/Typography";
import GoogleMapsAutocomplete from "../../../components/PlacesAutocomplete2";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import Map from "../../../components/Map";
import {Marker} from "@react-google-maps/api";
import {useTranslation} from "react-i18next";
import {countries} from "../../../utils/countries";

const SelectDeliveryAddress = () => {
    const theme = useTheme()
    const {setDeliveryAddress, getDeliveryAddress, getDeliveryType, setDeliveryType, nextStep, getUsageCountry, setUsageCountry} = useContext(OrderContext)
    const [address, setAddress] = useState(getDeliveryAddress())
    const {t} = useTranslation()

    const displayAddress = () => `${address?.address?.country || ''}, ${address?.address?.city || ''} ${address?.address?.postal_code || ''} ${address?.address?.street || ''} ${address?.address?.street_number || ''}`

    return <Box className="white-card2">
        <Stack direction={{xs: 'column', md: 'row'}}>
            <Stack justifyContent="space-between" sx={{width: {xs: "100%", md: "90%"}, padding: "20px"}}>
                <Stack spacing={1}>
                    <Typography variant="headline4">{t('new_order.delivery_address')}</Typography>
                    <Typography variant="body2">{t('new_order.selected_address')}: {Boolean(getDeliveryType()) ? '1113 Budapest, Bocskai út 77-79. III. emelet' : displayAddress()}</Typography>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox
                                checked={Boolean(getDeliveryType())}
                                onChange={e => setDeliveryType(e.target.checked ? 'TGS Iroda' : '')}
                            />}
                            label={<Typography variant="caption" color={theme.palette.primary[500]}>{t('new_order.pick_up')}</Typography>}/>
                    </FormGroup>
                    <Typography variant="caption" color={theme.palette.primary[500]}>{t('orders.usage_country')}</Typography>
                    <Autocomplete
                        id="country-select"
                        options={countries}
                        autoHighlight
                        getOptionLabel={(option) => option.label}
                        value={countries.find(country => country.code === getUsageCountry()) || null}
                        onChange={(event, newValue) => {
                            setUsageCountry(newValue?.code || '');
                        }}
                        renderOption={(props, option) => (
                            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                <img
                                    loading="lazy"
                                    width="20"
                                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                    alt=""
                                />
                                {option.label} ({option.code})
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                }}
                            />
                        )}
                    />
                    <Typography variant="caption" color={theme.palette.primary[500]}>{t('new_order.type_address')}</Typography>
                    <GoogleMapsAutocomplete disabled={Boolean(getDeliveryType())} setAddress={setAddress}/>
                </Stack>
                <Button sx={{marginTop: 2}} onClick={() => {
                    setDeliveryAddress(address)
                    nextStep()
                }} disabled={(!address?.coordinates && !Boolean(getDeliveryType())) || !getUsageCountry()} variant="outlined"
                        endIcon={<NavigateNextRoundedIcon/>}>{t('general.next')}</Button>
            </Stack>
            <Map center={address?.coordinates}>
                {address?.coordinates && <Marker position={address?.coordinates}/>}
            </Map>
        </Stack>
    </Box>
}

export default SelectDeliveryAddress